<template>
  <div class="row body home"  onselectstart="return false;">
    <div class="col-md-12">
      <div class="row">
      <div class="col-md-12 banner">
        <img class="banner-img" src="@static/img/news/banner.png" height="627px" width="100%" alt />
        <span class="banner-title" v-text="$t('home_page.name')"></span>
        <span class="banner-slogan" v-text="$t('home_page.slogan')"></span>
        <!-- <button class="banner-btn user-btn" v-text="$t('home_page.user_download')" @click="downloadUserApp"></button>
        <button class="banner-btn agent-btn" v-text="$t('home_page.agent_download')" @click="downloadAgentApp"></button> -->
      </div>
    </div>
        <div class="row">
          <div class="col-md-12">
            <div class="banner2">
              <div class="top">
                  <div class="item">
                    <img src="@static/img/home/scan.png" alt="">
                    <span v-text="$t('home_page.scanDesc')"></span>
                  </div>
                  <div class="item">
                    <img src="@static/img/home/fast.png" alt="">
                    <span v-text="$t('home_page.flashDesc')"></span>
                  </div>
                  <div class="item">
                    <img src="@static/img/home/location.png" alt="">
                    <span v-text="$t('home_page.locationDesc')"></span>
                  </div>
                  <div class="item">
                    <img src="@static/img/home/charge.png" alt="">
                    <span v-text="$t('home_page.phoneDesc')"></span>
                  </div>
              </div>
              <div class="img">
                <img class="banner-img" src="@static/img/home/banner2.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-12">
            <div class="desc banner3">
                <span class="title" v-text="$t('home_page.banner3Title')">WE HAVE GREAT INSIGHT</span>
                <p class="content" v-text="$t('home_page.banner3Text')">
                  Sichuan XiuDian Technology Co., Ltd. is a high-tech company focusing on R&D solutions, sales and services of shared power bank business. The company is committed to providing system integration solutions, development tools, platform management and operation solutions for customers in various industries.
The company's R&D, product management and business expansion covers the complete chain of shared power bank solutions, including hardware design and manufacturing product management, terminal multi-purpose management, offline and online billing platform, background operation management system, and service provider system. At the same time, we have strong marketing and product R&D operation support capabilities.
                </p>
            </div>
          </div>
        </div> -->
        <div class="row prodcut-item">
          <div class="col-md-12">
            <div class="title">
              <span  v-text="$t('home_page.productTitle')"></span>
            </div>
          </div>
          <div class="col-md-4 u800">
            <div class="item" @click="goDetail('u800')">
                <div class="img-warp border">
                  <img width="330px" height="270px" src="@static/img/home/k16_16.png" alt="">
                </div>
                <span class="name" v-text="$t('home_page.k16Desc')"></span>
            </div>
          </div>
          <div class="col-md-4 u600">
            <div class="item" @click="goDetail('u600')">
              <div class="img-warp border">
                <img width="330px" height="270px" src="@static/img/home/k16_12.png" alt="">
              </div>
              <span class="name" v-text="$t('home_page.k12Desc')"></span>
            </div>
          </div>
          <div class="col-md-4 u300">
            <div class="item" @click="goDetail('u300')">
              <div class="img-warp border">
                <img width="330px" height="270px" src="@static/img/home/k16_8.png" alt="">
              </div>
              <span class="name" v-text="$t('home_page.k8Desc')"></span>
            </div>
          </div>
        </div>
        <!-- <div class="row prodcut-item" style="display: flex;">
          <div class="col-md-4 l3000">
            <div class="item" @click="goDetail('l3000')">
              <div class="img-warp border">
                <img width="330px" height="270px" src="@static/img/home/l3000.png" alt="">
              </div>
              <span class="name" v-text="$t('home_page.l3000Desc')">L3000 Wired Charge Line</span>
            </div>
          </div>
        </div> -->
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'


export default {
  name: 'Home',
  methods : {
    goDetail : function (type) {
      this.$router.push('/product_introduce');
      localStorage.__$goDetail = type;
    },
    // downloadUserApp() {
    //   window.location.href = 'https://apps.apple.com/us/app/siu-power/id6745508656';
    // },
    // downloadAgentApp() {
    //   window.location.href = 'https://apps.apple.com/us/app/siu-power-agent/id6745775801';
    // },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    
  },
  // created() {
  //   var self = this;
  //   this.ajax
  //   .post("/img/list", {})
  //   .then((res) => {
  //     if("0000" === res.data.code) {
  //       res.data.result.rows.forEach(item => {
  //         self.swiperSlides.push(item);
  //       });
  //     }
  //   })
  //   .catch(function(error) {
  //     console.error(error);
  //   });
  // },
  data () {
    return {
      swiperOption: {
        speed : 2000,
        
        autoplay : {
          delay : 5000
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable:true

        }
      },
      swiperSlides: []
    }
  },
  components : {
    swiper, 
    swiperSlide
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.banner {
  position: relative;
}
.banner-title {
  position: absolute;
  left: 0;
  top: 240px;
  font-size: 80px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  width: 100%;
}
.banner-slogan {
  position: absolute;
  left: 0;
  top: 360px;
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  width: 100%;
}
.banner-btn {
  position: absolute;
  top: 500px;
  width: 360px;
  height: 100px;
  border-radius: 50px;
  border: none;
  font-weight: 700;
  font-size: 36px;
  line-height: 100px;
  text-align: center;
}
.user-btn {
  right: calc(50% + 60px);
  background-color: #0CBEB4;
  color: #FFFFFF;
}
.agent-btn {
  left: calc(50% + 60px);
  background-color: #FFFFFF;
  color: #0CBEB4;;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue